export default {
  api: 'https://stage-core.onsite7.co.uk/api',
  socket: 'https://stage-socket.onsite7.co.uk',
  googleApiKey: 'AIzaSyAavcFM10uewQsAz4bxf3YW5L911bQJB-A',
};
